import React from "react";
import { Button as ButtonMaterial } from "@mui/material";

const Button = ({ text, onClick }) => {
    return <ButtonMaterial 
              size="large" 
              variant="contained" 
              color="primary" 
              onClick={onClick}
              sx={{
                borderRadius: 2,
                height: 56,
                fontFamily: "Roboto, sans-serif",
                backgroundColor: "rgb(85, 94, 238)",
                "&:hover": {
                  backgroundColor: "rgb(100, 110, 245)",
                }
              }}
            >{text}</ButtonMaterial>
  };
  
  export default Button;
  